export default "__VITE_ASSET__DV5w7BG6__"